import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../network/apis/payroll";
import { getEventRequestListMeta } from "../../components/Events/Event/Applicants/eventRequestMappers";
import { showErrorMsg } from "../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

const getPayrollsApi = (portal) =>
  portal === "company" ? apis.getCompanyPayrolls : apis.getAdminPayrolls;

const getPaymentCountsApi = (portal) =>
  portal === "company"
    ? apis.getCompanyPayrollPaymentCounts
    : apis.getAdminPayrollPaymentCounts;

function* getEventPayrollsSaga({ payload }) {
  try {
    const { portal, eventId, params } = payload;
    const response = yield call(getPayrollsApi(portal), { eventId, params });
    const meta = getEventRequestListMeta(response);
    const data = response?.data?.data || {};

    yield put(
      actions.getEventPayrollsResponse({
        list: data.payrolls || [],
        meta,
        totals: {
          totalDeductions: data.total_deductions || 0,
          totalRewards: data.total_rewards || 0,
          totalNetPay: data.total_net_pay || 0,
        },
      }),
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getEventPayrollStatsSaga({ payload }) {
  try {
    const { portal, eventId } = payload;
    const response = yield call(getPaymentCountsApi(portal), { eventId, params: {} });
    const data = response?.data?.data || {};

    yield put(
      actions.getEventPayrollStatsResponse({
        paidCount: data.number_of_paid_users || 0,
        pendingCount: data.number_of_unpaid_users || 0,
      }),
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* payrollSagas() {
  yield takeEvery(types.GET_EVENT_PAYROLLS_REQUEST, getEventPayrollsSaga);
  yield takeEvery(
    types.GET_EVENT_PAYROLL_STATS_REQUEST,
    getEventPayrollStatsSaga,
  );
}
